export const youtubeThumbnail = (
  youtubeUrl: string | null | undefined,
  format:
    | '0'
    | '1'
    | '2'
    | '3'
    | 'default'
    | 'hqdefault'
    | 'mqdefault'
    | 'sddefault'
    | 'maxresdefault' = 'default'
) => {
  if (!youtubeUrl) {
    return '/images/no-image.svg'
  }

  return youtubeUrl
    .replace('https://www.youtube.com/watch?v=', `https://img.youtube.com/vi/`)
    .concat(`/${format}.jpg`)
}
